import { Photo } from '~/models/photos/types'

export function formatPhoto(p: any): Photo {
  const { name, is_panoramic: isPanoramic } = p
  // jesus
  const sizes = p.sizes || p.files
  return {
    isPanoramic,
    name,
    sizes: {
      a: sizes.size_a,
      b: sizes.size_b,
      h: sizes.size_h,
      k: sizes.size_k,
      m: sizes.size_m,
      n: sizes.size_n,
      p: sizes.size_p,
      t: sizes.size_t,
      v: sizes.size_v,
      z: sizes.size_z,
      h360: sizes.h360 || undefined,
      m360: sizes.m360 || undefined
    },
    title: p.title
  }
}
